(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.submain
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.submain', [
    ]);
}());
